<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18cOiNH/tc-custom/9783968650210.jpg" alt="This image is the cover for the book The Highest Mountain and seven more Stories Vol II, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Highest Mountain and seven more Stories Vol II, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Eight Classic Short Stories from The Golden Age of Science Fiction by Bryce Walton. Featured here: "The Highest Mountain", "Dreamer's World", "Freeway", "The Happy Nerd", "The Chasm", "War Game", "The Floater", and "Dark Windows",</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bryce Walton
      </h2>
      
      <p class="authorDescription body article">Bryce Walton (May 31, 1918 – February 5, 1988) was an American pulp fiction writer.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?62f974b7